/**
 * Returns true when the current zoom is below the required minimum.
 * Rounds to 1 decimal place so the check matches the zoom level
 * displayed in the UI (which uses toFixed).
 */
export function isBelowMinZoom(zoom: number, minZoom: number): boolean {
  return Math.round(zoom * 10) / 10 < minZoom;
}
